const serialize = function (form) {
    if (typeof form != "object" || form.nodeName !== "FORM") return "";
    const s = [];
    [...form.elements].forEach(function (field) {
        if (!field.name
            || field.disabled
            || field.type === "file"
            || field.type === "reset"
            || field.type === "submit"
            || field.type === "button")
            return;

        if (field.type === "select-multiple") {
            field.options.forEach(function (option) {
                if (!option.selected) return;
                s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(option.value);
            });
        } else if ((field.type !== "checkbox" && field.type !== "radio") || field.checked) {
            s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
        }
    });
    return s.join("&").replace(/%20/g, "+");
};

export const Form = {
    serialize: serialize
}


// WEBPACK FOOTER //
// ./uPortal/Content/js/Extensions/form.js